import { useField, useForm } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { Select, SelectProps } from './Select'

export type SelectFieldProps<Item> = Omit<SelectProps<Item>, 'value' | 'onChange'> & {
  name: string
  displayErrorIfUntouched?: boolean
  onChange?: (value: Item | null) => void
  validate?: FieldValidator<Item>
}

export function SelectField<Item extends { id: string }>({
  name,
  displayErrorIfUntouched,
  validate,
  onChange,
  ...props
}: SelectFieldProps<Item>) {
  const form = useForm()
  const { input, meta } = useField<Item>(name, { validate })

  const errorMessage = meta.error || meta.submitError || props.error

  const error = displayErrorIfUntouched ? errorMessage : meta.touched && errorMessage

  return (
    <Select<Item>
      {...input}
      value={input.value ?? null}
      onChange={(value) => {
        form.change(name, value ?? undefined)
        onChange?.(value)
      }}
      {...props}
      error={Boolean(error)}
      formHelperText={error || undefined}
    />
  )
}
